<div
  id="footer"
  class="footer no-print position-relative pb-7"
  (document:scroll)="scrolled($event.target)"
  (window:resize)="onResize()"
>
  <div
    *ngIf="scrollTop"
    class="container px-lg-10 px-md-10 text-end"
    pageScroll
    pageScrollTarget="body"
    [pageScrollOffset]="0"
    [pageScrollDuration]="300"
    [pageScrollInterruptible]="false"
    [pageScrollEasing]="defaultEasingLogic"
    @appear
  >
    <span class="scroll-trigger fa-arrow-up-long fa-solid h2 position-relative" role="button"></span>
  </div>
  <div class="container px-lg-10 px-md-10">
    <div class="df-app-footer pt-3 pb-3 w-100">
      <div class="df-app-footer-line align-items-stretch" *dfIfMedia="['md', 'lg', 'xl', 'xxl', 'xxxl']">
        <div *ngFor="let section of topLinks" class="col-3">
          <h4 class="text-nowrap section-title">{{ section.title }}</h4>
          <ng-container [ngTemplateOutlet]="linkWrapper" [ngTemplateOutletContext]="{section}"></ng-container>
        </div>
      </div>
    </div>
    <ngb-accordion class="df-accordion" *dfIfMedia="['xs', 'sm']">
      <ng-container *ngFor="let section of topLinks; let i = index">
        <ngb-panel title="{{ section.title }}">
          <ng-template ngbPanelContent>
            <ng-container [ngTemplateOutlet]="linkWrapper" [ngTemplateOutletContext]="{section}"></ng-container>
          </ng-template>
        </ngb-panel>
      </ng-container>
    </ngb-accordion>
    <hr class="spacing-05 w-100" />
    <div *ngIf="socialLinks.length || locales.length" class="df-app-footer-line flex-column flex-md-row footer-hebrew d-flex flex-row-reverse">
      <div class="order-1 d-flex align-items-center">
        <ng-container *ngIf="stores.length && stores.length > 1">
          <span class="icon-container me-4">
            <span class="fa-earth-americas ms-2"></span>
          </span>
          <ng-container *ngFor="let item of stores; let last = last">
            <a (click)="setLang(item)" [ngClass]="item.preferred ? 'fw-bold' : ''">{{ item.title }}</a>
            <div *ngIf="!last" role="separator" aria-orientation="vertical" class="vertical-separator mx-3"></div>
          </ng-container>
        </ng-container>
      </div>
      <div class="footer-auto mb-4 mb-md-0 order-0 order-md-2 d-flex flex-nowrap">
        <a
          *ngFor="let pair of socialLinks; let first = first"
          class="df-link-icononly icon-df-{{ pair[0] }} df-icon-solid"
          [ngClass]="{ 'ms-5': !first }"
          href="{{ pair[1] }}"
          rel="noopener noreferrer"
        >
        </a>
      </div>
    </div>
    <hr class="spacing-05 w-100" />
    <div class="df-app-footer-line d-flex flex-md-row flex-column flex-nowrap footer-hebrew" >
      <div class="footer-div">
        <a class="df-footer-brand mb-3 mb-md-0" href="https://amadeus.com" target="_blank">
          <div class="logo-embed df-logo-dim"><span class="visually-hidden">Amadeus</span></div>
        </a>
        <div class="ms-2 text-nowrap">© Amadeus IT Group SA</div>
      </div>
      <div class="d-flex flex-row footer-auto flex-wrap justify-content-center justify-content-md-end">
        <ng-container *ngFor="let link of legalLinks">
          <a
            id="{{ link.code }}"
            class="ms-4"
            target="{{ e2eMode.e2e ? '_self' : '_blank' }}"
            rel="noopener noreferrer"
            [routerLink]="['/content/', link.cms_page_code]"
          >
            {{ link.title }}
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #linkWrapper let-section="section">
  <ng-container *ngIf="'contactus' === section.code" [ngTemplateOutlet]="contactus"> </ng-container>
  <ng-container [ngTemplateOutlet]="links" [ngTemplateOutletContext]="{section}"></ng-container>
</ng-template>

<ng-template #contactus>
  <div *ngIf="contact['name']" [innerHTML]="contact['name']"></div>
  <div *ngIf="contact['address']" [innerHTML]="contact['address']"></div>
  <div *ngIf="contact['phone']" [innerHTML]="contact['phone']"></div>
</ng-template>

<ng-template #links let-section="section">
  <ng-container *ngFor="let child of refineItems(section.children); trackBy: itemTrackBy">
    <ng-container [ngSwitch]="child.item_type">
      <ng-container *ngSwitchCase="'external_link'">
        <a
          id="{{ child.code | lowercase }}"
          class="d-block"
          *ngIf="ssoCodes.indexOf(child.code) !== -1; else extLink"
          href="javascript:void(0)"
          (click)="navigateBySSOLink(child)"
        >
          {{ child.title }}
          <span class="fa-arrow-up-right-from-square df-icon-wtd sso-title"></span>
        </a>
        <ng-template #extLink>
          <a id="{{ child.code | lowercase }}" class="d-block" (click)="navigateBySSOLink(child)">
            {{ child.title }}
            <span class="sso-title fa-arrow-up-right-from-square df-icon-wtd"></span>
          </a>
          <span class=" sso-title"></span>
        </ng-template>
      </ng-container>
      <a
        id="{{ child.code | lowercase }}"
        *ngSwitchDefault
        class="d-block"
        [routerLink]="[child.link]"
        routerLinkActive="active-link"
        >{{ child.title }}</a
      >
    </ng-container>
  </ng-container>
</ng-template>
